import React, { createContext, useState, useEffect } from 'react';
let moment = require('moment');

export const MrbContext = createContext({});

/**
 * MRB context provider
 * @param {Array} data
 * @param {JSX.Element} children
 * @returns {JSX.Element}
 */
export const MrbContextProvider = ({ data, children }) => {
  const [orderedData, setOrderedData] = useState([]);
  const [orderBy, setOrderBy] = useState('number');
  const [orderType, setOrderType] = useState('asc');

  useEffect(() => {
    setOrderedData(data.length > 0 ? data : []);
  }, [data]);

  useEffect(() => {
    _orderData('asc');
  }, [orderBy]);

  const _selectOrderBy = (option) => {
    setOrderBy(option);
  }

  const _orderData = (type) => {
    setOrderType(type);
  }

  return (
    <MrbContext.Provider value={{
      data: orderedData,
      orderType: orderType,
      orderBy: orderBy,
      orderData: (type) => _orderData(type),
      selectOrderBy: (option) => {_selectOrderBy(option)}
    }}>
      {children}
    </MrbContext.Provider>
  )
}

